
global.version = "1.0.0";
global.email = "zenithlinkit@hotmail.com";
global.work_data = [
  {
    image_url: require("../assets/images/work/work-1.jpg"),
    title: "เว็บไซต์ คณะมนุษศาสตร์และสังคมศาสตร์ มหาวิทยาลัยราชภัฏเชียงใหม่",
    description: "มหาวิทยาลัยราชภัฏเชียงใหม่ Chiang Mai Rajabhat University (CMRU) คณะมนุษศาสตร์และสังคมศาสตร์ ภาควิชามนุษศาสตร์ สาขาวิชาภาษาไทย",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-2.jpg"),
    title: "เว็บไซต์ บ้านสาลาแม่ทา มินิ มาราธอน",
    description: "บ้านสาลาแม่ทา มินิ มาราธอน Bansala maetha mini marathon",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-3.jpg"),
    title: "เว็บไซต์ มหาเศรษฐีใหม่ Ai Corp",
    description: "มหาเศรษฐีใหม่ Ai Corp Product การเกษตร, อาหารเสริมเพื่อสุขภาพ, เสริมสวยและความงาม, อุปโภคบริโภค, แผนการตลาด และอื่นๆ อีกมากมาย",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-4.jpg"),
    title: "เว็บไซต์ 159 kingpower",
    description: "เครื่องดื่มชูกำลัง 159 kingpower บจก.ทูเก็ตเตอร์(ไทยแลนด์) เติมพลัง เติมความฝัน เติมเต็มให้กัน",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-5.jpg"),
    title: "แพลตฟอร์ม Pao Pao Supermaket",
    description: "Pao Pao Supermaket จำหน่ายสินค้าหลากหลายรูปแบบ ทั้งปลีก-ส่ง และอื่นๆ มากมาย",
    url: "",
    type: "website,application",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-6.jpg"),
    title: "เว็บไซต์ เซฟไทยคลีนเอเนอจี",
    description: "เซฟไทยคลีนเอเนอจี บริษัท เซฟไทยคลีนเอเนอร์จี จำกัด โครงการพลังงานสะอาดเพื่อสุขภาพคนไทย",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-7.jpg"),
    title: "แพลตฟอร์ม Haladiem Security",
    description: "Haladiem Security บริษัทรักษาความปลอดภัย ฮาลาเดียม จำกัด ประกอบธุรกิจให้บริการด้านรักษาความปลอดภัย",
    url: "",
    type: "website,application",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-8.jpg"),
    title: "เว็บไซต์ Grit technology",
    description: "Grit technology บริษัทที่ให้บริการทางด้านเทคโนโลยี ทุกธุรกิจที่ต้องการการเติบโตบนโลกออนไลน์",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-9.jpg"),
    title: "เว็บไซต์ J.M. Language center",
    description: "ศูนย์ภาษาจีนและญี่ปุ่นที่ดีที่สุดในจังหวัด เชียงใหม่เพียบพร้อมด้วยครูผู้มากความสามารถ",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-10.jpg"),
    title: "แพลตฟอร์ม Ninja Cargo",
    description: "Ninja Cargo บริการนำเข้าจากประเทศจีนมาไทย ด้วยทีมงานมืออาชีพพร้อมเคลียร์ภาษี นำเข้าอย่างถูกต้องตามกฎหมาย",
    url: "",
    type: "website,application,iot",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-11.jpg"),
    title: "เว็บไซต์ Virtual Run Korat",
    description: "Virtual Run Korat ชวนวิ่งท่องเที่ยวทั่วเมืองโคราช Virtual Run to Travel Around Korat พร้อมเหรียญที่ระลึกของสถานที่สวยงามต่างๆ",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-12.jpg"),
    title: "เว็บไซต์ Lamphun City",
    description: "เทศบาลเมืองลำพูน ให้บริการประชาชน แจ้งข่าวสารต่างๆ ลำพูนเมืองน่าอยู่ ประชาชนมีคุณภาพชีวิตที่ดี",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-13.jpg"),
    title: "แพลตฟอร์ม PrivilegeX",
    description: "บริการจัดการเกี่ยวกับความงานทุกรูปแบบ ด้วยบริการต่างๆ แต้มพิเศษแลกบริการ ผ่าน mobile app และระบบหลังบ้าน",
    url: "",
    type: "website,application",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-14.jpg"),
    title: "เว็บไซต์ MOE-Smart Office",
    description: "โครงการพัฒนาระบบสำนักงานอัจฉริยะ ระยะที่ 2 มหาวิทยาลัยรังสิต Rangsit University (RSU)",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-15.jpg"),
    title: "แพลตฟอร์ม Legal Entity",
    description: "ระบบนิติบุคคล ต่อยอดจาก Haladiem Security บริษัทรักษาความปลอดภัย ฮาลาเดียม จำกัด ประกอบธุรกิจให้บริการด้านรักษาความปลอดภัย",
    url: "",
    type: "website,application",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-16.jpg"),
    title: "แพลตฟอร์ม Air Shop",
    description: "ระบบ pos เกี่ยวกับการขายแอร์ครบวงจร บริการหลากหลาย ด้านการซื้อขาย ฝากขาย งานซ่อม ติดตั้ง อะไหล่ และอื่นๆ อีกมากมาย",
    url: "",
    type: "website,pos",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-17.jpg"),
    title: "เว็บไซต์ ศูนย์รับคำขออนุญาตของกรุงเทพมหานคร",
    description: "ระบบ ยื่นคำขออนุญาติ - ติดตามสถานะ ชำระค่าธรรมเนียม ผ่านออนไลน์ได้แล้ว เพื่ออำนวยความสะดวกแก่ประชาชน และผู้ประกอบการ",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-18.jpg"),
    title: "แพลตฟอร์ม Easy Store",
    description: "ระบบ บริหารจัดการสต๊อก ดูแลและจัดการข้อมูลสต๊อกให้เป็นเรื่องงาน พร้อมฟีเจอร์ และบริหารมากมาย",
    url: "",
    type: "website,pos",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-19.jpg"),
    title: "เว็บไซต์ มหาวิทยาลัยรังสิต",
    description: "สถาบันอุดมศึกษา ที่ได้รับการประเมิน จากสำนักงานรับรองมาตรฐานและประเมินคุณภาพการศึกษา (สมศ.)",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-20.jpg"),
    title: "เว็บไซต์ C.D.S",
    description: "ระบบ นิติบุคคลโครงการ บ้านเอื้ออาทร ดูแลและจัดการข้อมูลส่วนกลาง และ ค่าบริการ การจัดเก็บ ดูแลรักษาบ้านเอื้ออาทร",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-21.jpg"),
    title: "แพลตฟอร์ม M - Help",
    description: "กระทรวงสาธารณสุข ระบบ M - Help ในการกำจัดโรคไข้มาลาเรีย พัฒนาระบบเฝ้าระวังโรคและ การตอบโต้สถานการณ์โรค และอื่นๆมากมาย",
    url: "",
    type: "website,application",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-22.jpg"),
    title: "แพลตฟอร์ม SK Service",
    description: "ระบบ บริการให้เช่ารถมอเตอร์ ในจังหวัดเชียงใหม่ มีบริการรับส่ง ปลอดภัยและมีสภาพพร้อมใช้งาน มีระบบเก็บแต้มแลกใช้งานมากมาย",
    url: "",
    type: "website,application,pos",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-23.jpg"),
    title: "แพลตฟอร์ม GuardX",
    description: "ระบบ ควบคุมการทำงานของเจ้าหน้าที่ รักษาความปลอดภัย ในการเดินตรวจตรา ยังตำแหน่งหรือพื้นที่ต่างๆ ที่ได้ถูกกำหนดไว้",
    url: "",
    type: "website,application",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-24.jpg"),
    title: "เว็บไซต์ OL Service",
    description: "ระบบ อู่ซ่อมรถใหญ่ รถบรรทุก รถสิบล้อ ทุกชนิด บริการประกอบและติดตั้งตู้บรรทุกต่างๆ เน้นคุณภาพของงานและบริการ",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-25.jpg"),
    title: "เว็บไซต์ Fict Coding Thailand",
    description: "นิทรรศการส่งเสริมการเรียนรู้ด้านดิจิทัล หลักสูตรการเรียนรู้ Coding กิจกรรม Boots CampRoad Show และอื่นๆ มากมาย",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-26.jpg"),
    title: "เว็บไซต์ CLMV - iService",
    description: "ระบบ ทะเบียนนายจ้าง ลูกจ้าง ที่เป็นแรงงานต่างด้าว ร่วมกับกรมการค้า และหน่วยงานราชการที่เกี่ยวข้อง",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-27.jpg"),
    title: "🟢เว็บไซต์ Senovate AI",
    description: "จัดการฟาร์มปศุสัตว์ในเขตร้อนชื้น เซ็นเซอร์ติดตามพฤติกรรมสัตว์ จับคู่ และอื่นๆ มีผู้เชี่ยวชาญในด้านเทคโนโลยีการติดตามพฤติกรรมและการรักษาโคนม",
    url: "",
    type: "website,application",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-28.jpg"),
    title: "เว็บไซต์ Steakkinkab",
    description: "สเต็กกินกับ อาหารคลีน เจ้าแรก บน เดริเวอร์รี่ ที่มีซอสคลีน ไม่จืด แฟรนไชส์ อาหารคลีน มีกว่า 100 สาขา ทั่วประเทศ",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-29.jpg"),
    title: "แพลตฟอร์ม Aimhengjan",
    description: "ระบบ pos เกี่ยวกับการขายส่งผ้าหลา ราคาส่งและถูกที่สุด ในนราธิวาส มีหน้าร้านและบริการจัดส่งทั่วประเทศ",
    url: "",
    type: "website,pos",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-30.jpg"),
    title: "🟢เว็บไซต์ Lemonaid Rent Car",
    description: "Lemonaide เป็นบริษัทซอฟต์แวร์ที่มุ่งเน้นพัฒนาเทคโนโลยี และให้บริการครบวงจรสำหรับธุรกิจยานยนต์",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-31.jpg"),
    title: "🟢เว็บไซต์ เชียงรายกายภาพบำบัด คลินิก",
    description: "คลินิกกายภาพบำบัดในจังหวัดเชียงราย,เชียงรายกายภาพบำบัดคลินิก,คลินิกจัดกระดูก,รักษาหมอน,รองกระดูกทับเส้นประสาท,รักษาออฟฟิตซินโดรม,ปวดสะโพกชาร้าวลงขา,ข้อไหล่ติด,นิ้วล็อก,กระดูกสันหลังคด,รักษารองช้ำ ปวดส้นเท้า",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-32.jpg"),
    title: "เว็บไซต์ coway thailand",
    description: "แบรนด์ subscription เครื่องกรองน้ำและเครื่องฟอกอากาศที่น่าเชื่อถืออันดับ 1",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-33.jpg"),
    title: "เว็บไซต์ EZ Clinic",
    description: "โปรแกรมบริหารงานคลินิก สะดวก ง่าย ใช้งานได้ทุกที่ ทุกเวลา รองรับการใช้งานบนมือถือ ทำบัตรและนัด…ง่าย ออกบิล…เร็ว สรุปบัญชี…ไม่มีพลาด “ง่ายๆ แค่ปลายนิ้วคลิก”",
    url: "",
    type: "website",
    stax: "React,Node.js,MySQL"
  },
  {
    image_url: require("../assets/images/work/work-34.jpg"),
    title: "แพลตฟอร์ม เซียงกง อะไหล่ยนต์",
    description: "จำหน่าย อะไหล่รถยนต์แท้ทุกชนิด เครื่องยนต์ ดีเซล เบนซิน หัวฉีดเทอร์โบ และช่างล่างรถใหญ่ - เล็ก นำเข้าจากประเทศญี่ปุ่นโดยตรง",
    url: "",
    type: "website,application",
    stax: "React,Node.js,MySQL"
  },
];